import { render, staticRenderFns } from "./MouldEdit.vue?vue&type=template&id=27f2e501&"
import script from "./MouldEdit.vue?vue&type=script&lang=js&"
export * from "./MouldEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports